var app = angular.module('leonardo');

var WPFormZone = function($timeout, $q, NotificationService, LevelService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      placeholder: '@',
    },
    templateUrl: 'views/templates/form/form-zone.html',
    link: function(scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.$input = element.find('.form-zone-input');
      scope.address = '';
      scope.lon = null;
      scope.lat = null;
      scope.init = false;
      scope.initModel = false;
      scope.initGeocoder = false;

      scope.states = {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AS': 'American Samoa',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FM': 'Federated States Of Micronesia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MH': 'Marshall Islands',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'MP': 'Northern Mariana Islands',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PW': 'Palau',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      };

      scope.initEvents = function() {
        scope.$on('address-street:updated', function($event, street) {
          scope.street = street;
          scope.updateModel();
        });

        scope.$on('address-level:updated', function($event, level_type, level) {
          scope[level_type] = level;
          scope.updateModel(true, level_type);
        });
      };

      scope.initNgModel = function() {
        if (scope.ngModelCtrl.$modelValue) {
          scope.initModel = true;
          scope.address = scope.ngModelCtrl.$modelValue.address;
          scope.lon = scope.ngModelCtrl.$modelValue.long;
          scope.lat = scope.ngModelCtrl.$modelValue.lat;
          scope.city = scope.ngModelCtrl.$modelValue.city;
          scope.state = scope.ngModelCtrl.$modelValue.state;
          scope.county = scope.ngModelCtrl.$modelValue.county;
          scope.zipcode = scope.ngModelCtrl.$modelValue.zipcode;
          scope.street = scope.ngModelCtrl.$modelValue.street;
        }
        scope.$input.val(scope.address);
        scope.updateModel(true);
        scope.initGeocoder = true;
      };

      scope.ngModelCtrl.$render = function() {
        scope.initNgModel();
        scope.initEvents();
      };

      scope.updateModel = function(updateLevels, level_type) {
        var promises = [];
        if (updateLevels) {
          var levels_keys = level_type ? [level_type] : ['state', 'county', 'city', 'zipcode'];
          angular.forEach(levels_keys, function (key) {
            if (scope[key]) {
              promises.push(LevelService.get(scope[key], true).then(function (level){
                switch (level.level_type) {
                  case LevelService.TYPE_STATE:
                    scope.state_name = level.name;
                    break;
                  case LevelService.TYPE_COUNTY:
                    scope.county_name = level.name;
                    break;
                  case LevelService.TYPE_CITY:
                    scope.city_name = level.name;
                    break;
                  case LevelService.TYPE_ZIPCODE:
                    scope.zipcode_name = level.name;
                    break;
                }
              }));
            }
            else {
              scope[key+'_name'] = null;
            }
          });
        }
        $q.all(promises).then(function (){
          scope.address = '';
          if (scope.street) {
            scope.address += scope.street + ', ';
          }
          if (scope.city_name) {
            scope.address += scope.city_name + ', ';
          }
          if (scope.state_name) {
            scope.address += (scope.states[scope.state_name] || scope.state_name) + ', ';
          }
          if (scope.zipcode_name) {
            scope.address += scope.zipcode_name + ', ';
          }
          scope.address = scope.address.slice(0, -2);
          scope.ngModelCtrl.$setViewValue({
            address: scope.address,
            long: scope.lon,
            lat: scope.lat,
            city: scope.city,
            state: scope.state,
            county: scope.county,
            zipcode: scope.zipcode,
            street: scope.street
          });
          scope.init = true;
        });
      };

      scope.$input.bind('keydown keypress', function(event) {
        if (!scope.init) {
          scope.init = true;
        }
        if (event.keyCode === 13) {
          event.preventDefault();
        }
      });

      scope.$watch('ngModelCtrl', function (newVal, oldVal) {
        if (!angular.equals(newVal, oldVal) && !scope.initModel) {
          scope.initNgModel();
        }
      });

    }
  };
};

app.directive('wpFormZone', ['$timeout', '$q', 'NotificationService', 'LevelService', WPFormZone]);
